module.exports = __webpack_public_path__ + "static/media/0025.ace08999.jpg";